import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { fetchPublic } from "../lib/content";

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchPublic("testimonials").then(setItems).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-20 md:py-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <SectionHeader
          eyebrow="Student Stories"
          title="Sapno se safalta — real journeys."
          desc="Hear from students who started with a dream and reached real careers with TASSEI."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <article
              key={t.id}
              data-testid={`testimonial-${i}`}
              className="relative bg-white border border-slate-200 rounded-2xl p-6 md:p-7 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0A192F]/5 transition-all duration-300"
            >
              <Quote className="w-7 h-7 text-[#00B37E] opacity-70" />
              <p className="mt-4 text-[#334155] leading-relaxed">&ldquo;{t.quote}&rdquo;</p>

              <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-3">
                {t.photo ? (
                  <img src={t.photo} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                ) : (
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#00B37E] to-[#0A192F] flex items-center justify-center text-white font-heading font-bold">
                    {t.name.split(" ").map((s) => s[0]).join("").slice(0, 2)}
                  </div>
                )}
                <div className="flex-1">
                  <div className="font-bold text-sm text-[#0A192F]">{t.name}</div>
                  <div className="text-xs text-[#64748B]">{t.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star key={idx} className="w-3.5 h-3.5 fill-[#F59E0B] text-[#F59E0B]" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
